import { useState } from 'react'
import { Button, Table } from 'antd'
import type { ColumnsType } from 'antd/lib/table'
import PreviewModal from '@/components/previewModal'
import { CustomerConfirm } from '../../../components/ModalUser'
import { getAttachTypeLabel } from './helpers'
import { AptitudeFile, AptitudeTableProps } from './typing'
import Style from './aptitudeAttach.module.scss'

// 资质附件表格：编辑页可删除，详情页 readOnly 只读
const AptitudeTable = (props: AptitudeTableProps) => {
  const { dataSource = [], onChange, readOnly } = props
  const [previewUrl, setPreviewUrl] = useState('')
  const [previewOpen, setPreviewOpen] = useState(false)

  const onPreview = (record: AptitudeFile) => {
    setPreviewUrl(`${record.baseUrl || ''}${record.url}`)
    setPreviewOpen(true)
  }

  const onDelete = (record: AptitudeFile) => {
    CustomerConfirm({
      title: '提示',
      content: '确认删除此资质文件吗？',
      onOk: () => {
        onChange?.(dataSource.filter((item) => item !== record))
      },
    })
  }

  const columns: ColumnsType<AptitudeFile> = [
    {
      title: '图片资质类型',
      dataIndex: 'docType',
      width: 260,
      render: (value: string) => getAttachTypeLabel(value),
    },
    {
      title: '文件名称',
      dataIndex: 'name',
      width: 220,
      ellipsis: true,
    },
    {
      title: '文件地址',
      dataIndex: 'url',
      ellipsis: true,
      render: (_: string, record: AptitudeFile) => (
        <Button
          type="link"
          style={{ padding: 0, height: 'auto' }}
          onClick={() => onPreview(record)}
        >
          <span className={Style.linkCell}>
            {`${record.baseUrl || ''}${record.url}`}
          </span>
        </Button>
      ),
    },
    {
      title: '操作',
      dataIndex: 'operate',
      width: 80,
      render: (_: unknown, record: AptitudeFile) =>
        readOnly ? null : (
          <Button
            type="link"
            danger
            style={{ padding: 0 }}
            onClick={() => onDelete(record)}
          >
            删除
          </Button>
        ),
    },
  ]

  return (
    <>
      <Table<AptitudeFile>
        size="small"
        rowKey={(record) => `${record.docType}_${record.url}`}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
      <PreviewModal
        open={previewOpen}
        fileUrl={previewUrl}
        onCancel={() => setPreviewOpen(false)}
      />
    </>
  )
}

export default AptitudeTable
import { useState } from 'react'
import { Button, Table } from 'antd'
import type { ColumnsType } from 'antd/lib/table'
import PreviewModal from '@/components/previewModal'
import { CustomerConfirm } from '../../../components/ModalUser'
import { getAttachTypeLabel } from './helpers'
import { AptitudeFile, AptitudeTableProps } from './typing'
import Style from './aptitudeAttach.module.scss'

// 资质附件表格：编辑页可删除，详情页 readOnly 只读
const AptitudeTable = (props: AptitudeTableProps) => {
  const { dataSource = [], onChange, readOnly } = props
  const [previewUrl, setPreviewUrl] = useState('')
  const [previewOpen, setPreviewOpen] = useState(false)

  const onPreview = (record: AptitudeFile) => {
    setPreviewUrl(`${record.baseUrl || ''}${record.url}`)
    setPreviewOpen(true)
  }

  const onDelete = (record: AptitudeFile) => {
    CustomerConfirm({
      title: '提示',
      content: '确认删除此资质文件吗？',
      onOk: () => {
        onChange?.(dataSource.filter((item) => item !== record))
      },
    })
  }

  const columns: ColumnsType<AptitudeFile> = [
    {
      title: '图片资质类型',
      dataIndex: 'docType',
      width: 260,
      render: (value: string) => getAttachTypeLabel(value),
    },
    {
      title: '文件名称',
      dataIndex: 'name',
      width: 220,
      ellipsis: true,
    },
    {
      title: '文件地址',
      dataIndex: 'url',
      ellipsis: true,
      render: (_: string, record: AptitudeFile) => (
        <Button
          type="link"
          style={{ padding: 0, height: 'auto' }}
          onClick={() => onPreview(record)}
        >
          <span className={Style.linkCell}>
            {`${record.baseUrl || ''}${record.url}`}
          </span>
        </Button>
      ),
    },
    {
      title: '操作',
      dataIndex: 'operate',
      width: 80,
      render: (_: unknown, record: AptitudeFile) =>
        readOnly ? null : (
          <Button
            type="link"
            danger
            style={{ padding: 0 }}
            onClick={() => onDelete(record)}
          >
            删除
          </Button>
        ),
    },
  ]

  return (
    <>
      <Table<AptitudeFile>
        size="small"
        rowKey={(record) => `${record.docType}_${record.url}`}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
      />
      <PreviewModal
        open={previewOpen}
        fileUrl={previewUrl}
        onCancel={() => setPreviewOpen(false)}
      />
    </>
  )
}

export default AptitudeTable
